module.exports = __webpack_public_path__ + "74d92cd8fa6656b2e9e4419cec617bad.svg";